import { useState, useEffect, useRef } from 'react'
import { INavbar } from '@/types/cinematics'

const AVG_NAV_ITEM_WIDTH = 100
const APP_LOGO_WIDTH = 90
const RESERVED_SPACE = 100

interface UseResponsiveItemsProps {
  items: INavbar['items']
}

export const useResponsiveItems = ({ items }: UseResponsiveItemsProps) => {
  const [collapsedItems, setCollapsedItems] = useState<INavbar['items']>([])
  const [visibleItems, setVisibleItems] = useState<INavbar['items']>(items)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleResize = () => {
      const containerWidth = containerRef.current?.offsetWidth || 0
      let totalWidth = 0
      const newVisibleItems: INavbar['items'] = []
      const newCollapsedItems: INavbar['items'] = []

      items.forEach((item) => {
        const itemWidth = AVG_NAV_ITEM_WIDTH
        if (totalWidth + itemWidth < containerWidth - RESERVED_SPACE - APP_LOGO_WIDTH) {
          newVisibleItems.push(item)
          totalWidth += itemWidth
        } else {
          newCollapsedItems.push(item)
        }
      })

      setVisibleItems(newVisibleItems)
      setCollapsedItems(newCollapsedItems)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [items])

  return { visibleItems, collapsedItems, containerRef }
}
